import { changeAnalyticsTaskAttribute } from '@process-advisor/process-miner/api/methods/analytics/changeAnalyticsTaskAttribute';
import { changeAnalyticsTaskAttributeMetric } from '@process-advisor/process-miner/api/methods/analytics/changeAnalyticsTaskAttributeMetric';
import { changeAnalyticsTaskHistoryMetric } from '@process-advisor/process-miner/api/methods/analytics/changeAnalyticsTaskHistoryMetric';
import { changeAnalyticsEventAttribute } from '@process-advisor/process-miner/api/methods/analytics/changeAnalyticsEventAttribute';
import { getAnalyticsTaskAttribute } from '@process-advisor/process-miner/api/methods/analytics/getAnalyticsTaskAttribute';
import { getAnalyticsTaskAttributeMetric } from '@process-advisor/process-miner/api/methods/analytics/getAnalyticsTaskAttributeMetric';
import { getAnalyticsTaskHistoryMetric } from '@process-advisor/process-miner/api/methods/analytics/getAnalyticsTaskHistoryMetric';
import { getTaskTable } from '@process-advisor/process-miner/api/methods/analytics/getTaskTable';
import { getDetailTaskSummaryAttribute} from '@process-advisor/process-miner/api/methods/analytics/getDetailTaskSummaryAttribute';
import { changeDetailTaskSummaryAttribute} from '@process-advisor/process-miner/api/methods/analytics/changeDetailTaskSummaryAttribute';
import { setTaskDetailExtract } from '@process-advisor/process-miner/api/methods/analytics/setTaskDetailExtract'
import { getDetailEventSummaryAttribute} from '@process-advisor/process-miner/api/methods/analytics/getDetailEventSummaryAttribute';
import { changeDetailEventSummaryAttribute} from '@process-advisor/process-miner/api/methods/analytics/changeDetailEventSummaryAttribute';
import { setEventDetailExtract } from '@process-advisor/process-miner/api/methods/analytics/setEventDetailExtract'
import { analyticsEventHistory } from '@process-advisor/process-miner/api/methods/analytics/analyticsEventHistory'
import { processAnalyticsHistory } from '@process-advisor/process-miner/api/methods/analytics/processAnalyticsHistory'
import { analyticsEventAttributes } from '@process-advisor/process-miner/api/methods/analytics/analyticsEventAttributes'

export const analyticsMethods = {
    getAnalyticsTaskAttributeMetric,
    getAnalyticsTaskHistoryMetric,
    changeAnalyticsTaskAttributeMetric,
    changeAnalyticsTaskAttribute,
    changeAnalyticsEventAttribute,
    getAnalyticsTaskAttribute,
    getTaskTable,
    getDetailTaskSummaryAttribute,
    changeDetailTaskSummaryAttribute,
    setTaskDetailExtract,
    setEventDetailExtract,
    changeDetailEventSummaryAttribute,
    getDetailEventSummaryAttribute,
    analyticsEventHistory,
    analyticsEventAttributes,
    changeAnalyticsTaskHistoryMetric,
    processAnalyticsHistory
};
